import { Stack } from '@appcues/sonar';
import styled from 'styled-components';

export const PageBody = styled(Stack)`
  max-width: 1400px;
  width: 100%;
  align-self: center;
  padding: var(--spacing-large) var(--spacing-x-large);

  @media (min-width: 1366px) {
    padding: var(--spacing-large) var(--spacing-x-x-x-large);
  }
`;
